module.exports = __webpack_public_path__ + "img/main_6.7bed1cfb.png";